
<template>
<div>
 <navTop :isLogin="1" title="相君科技签章教程"></navTop>

  <div style="display:flex; margin:20px 10%">
    <Video :src="src" :poster="poster" id="v"/>
    <div id="video">
      <div id="videoList">
        <ul>
            <h2>视频列表</h2>
            <li v-for="(item, index) in list"
            :key="index"
            :class="contentIndex === index ? 'selectVideo' : ''"
            @click="selectPlay(index)">
              <img v-if="contentIndex === index" :src="playing"/>
              {{item.name}}
            </li>
        </ul>
      </div>
    </div>
  </div>
  <navBom></navBom>
</div>
</template>
<script>
import Video from './video'
import navTop from '../nav/nav-top2.vue'
import navBom from '../nav/nav-bom.vue'


export default {
  name: 'VideoPlay',
  components: {
    Video,
    navTop,
    navBom
  },
  data () {
    return {
      
      // src: require('@/assets/files/Bao.mp4'), // 相对路径
      src: 'https://xiangjunkeji.cn/CM-API/upload/video/签章驱动.mp4',
      // poster: require('@/assets/images/Bao.jpg'),
      poster: '',
      playing:require('@/assets/playing.gif'),
      list:[{name:"驱动、浏览器安装",url:"https://xiangjunkeji.cn/CM-API/upload/video/签章驱动.mp4"},
            {name:"线上云章签署流程",url:"https://xiangjunkeji.cn/CM-API/upload/video/线上云章.mp4"},
            {name:"线上ukey签署流程",url:"https://xiangjunkeji.cn/CM-API/upload/video/线上ukey.mp4"},
            {name:"离线ukey签署流程",url:"https://xiangjunkeji.cn/CM-API/upload/video/离线签署.mp4"},
            {name:"线上云章服务购买",url:"https://xiangjunkeji.cn/CM-API/upload/video/服务购买.mp4"},
            {name:"其他操作问题说明",url:"https://xiangjunkeji.cn/CM-API/upload/video/其他说明.mp4"},
            ],
      contentIndex:0,
      
    }  
  },
  methods:{
    selectPlay(id){
      this.contentIndex=id
      this.src=this.list[id]['url']
    }
  }
}
</script>
<style>
  #v{
    border-radius:12px;
    box-shadow:5px 5px 10px  rgb(119,136,153,0.6) 
  }
  #video{
    float:right;
    width:30%;

  }
  #videoList{
    margin:0px 10%;
    width:80%;
    height:100%;
    border-radius:12px;
    font-size:18px;
    background:#ecf4f8;
    color:#004466;
    box-shadow:5px 5px 10px  rgb(119,136,153,0.6) 
  
  }
  #videoList ul{
    margin:0;
    padding:30px;
    list-style:none;

  }

    #videoList li{
    margin:5px 0;
    padding:15px;
    list-style:none;
  }

    #videoList h2{
    margin:5px 0 50px 0;

  }

  .selectVideo{
    background:white;
    border-radius:5px;
    display:flex;
    height:28px;
    color:#0088cc

  }
  .selectVideo img{
  margin-right:10px;
  height:100%

  }

</style>


// WEBPACK FOOTER //
// src/components/ukeyVideo/index.vue